const Spinner = () => {
  return (
    <div className='flex justify-center items-center h-full'>
      <div className='spinner border-t-transparent border-4 border-gray-200 w-12 h-12 rounded-full animate-spin'></div>
    </div>
  );
};

export default Spinner;
